module.exports = __webpack_public_path__ + "img/download_and.dd8ab8dc.png";